"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RailgunConfig = void 0;
class RailgunConfig {
    static SHIELD_FEE_BASIS_POINTS_FOR_NETWORK = {};
    static UNSHIELD_FEE_BASIS_POINTS_FOR_NETWORK = {};
    static getShieldFeeBasisPoints = (networkName) => {
        const shieldFee = this.SHIELD_FEE_BASIS_POINTS_FOR_NETWORK[networkName];
        if (!shieldFee) {
            throw new Error(`No shield fee defined for network ${networkName}.`);
        }
        return shieldFee;
    };
    static getUnshieldFeeBasisPoints = (networkName) => {
        const unshieldFee = this.UNSHIELD_FEE_BASIS_POINTS_FOR_NETWORK[networkName];
        if (!unshieldFee) {
            throw new Error(`No unshield fee defined for network ${networkName}.`);
        }
        return unshieldFee;
    };
}
exports.RailgunConfig = RailgunConfig;
